import { jsx as a, jsxs as V } from "react/jsx-runtime";
import { forwardRef as B, useState as d, useRef as j, useEffect as m, useMemo as ee, useCallback as z, useImperativeHandle as te } from "react";
import { createPortal as se } from "react-dom";
import n from "./styles.module.less.js";
import ie from "./close-icon.svg.js";
import { useDisableScroll as oe } from "../../../utils/use-disable-scroll.js";
import { PREMATTER_ID_COOKIE as re, ATTICUS_JOB_ID_KEY as ne, ATTICUS_EMAIL_KEY as ae, ATTICUS_PREMATTER_ID_KEY as D } from "../../../utils/atticus-storage-keys.js";
const ce = 200, le = B(
  ({
    defaultOpen: P = !1,
    onClose: u,
    onOpen: f,
    iframeUrl: C,
    category: v = null,
    suburb: $ = null,
    suburbId: U = null,
    utmContent: K,
    fromFirm: E,
    additionalParams: s = {},
    ga4MeasurementId: g,
    onIframeLoad: b,
    onCloseWithData: h,
    onShareBriefSuccess: p,
    source: L = "lawconnect",
    user: c,
    context: y
  }, Q) => {
    const [w, G] = d(P), [M, N] = d(!1), [I, O] = d(!1), [_, X] = d(""), [R, Z] = d(""), S = j(null), o = j(null), Y = j("");
    oe({ isDisabled: w }), m(() => {
      (() => {
        if (typeof window < "u" && window.gtag)
          try {
            if (g) {
              window.gtag(
                "get",
                g,
                "client_id",
                (e) => {
                  e && X(e);
                }
              ), window.gtag(
                "get",
                g,
                "session_id",
                (e) => {
                  e && Z(e);
                }
              );
              return;
            }
          } catch (e) {
            console.warn("Failed to get GA4 data from gtag:", e);
          }
      })();
    }, [g]);
    const T = ee(() => {
      const t = new URLSearchParams();
      Object.entries(s).forEach(([r, A]) => {
        r !== "client_id" && r !== "session_id" && t.append(r, A);
      }), _ && t.append("client_id", _), R && t.append("session_id", R);
      const e = t.toString();
      return `${C}${e ? `?${e}` : ""}`;
    }, [C, s, _, R]);
    m(() => {
      T !== Y.current && O(!1), Y.current = T;
    }, [T]);
    const F = z(() => {
      o.current && (clearTimeout(o.current), o.current = null), N(!1), G(!0), f == null || f();
    }, [f]), l = z(() => {
      o.current && clearTimeout(o.current), N(!0), o.current = setTimeout(() => {
        G(!1), N(!1), u == null || u();
      }, ce);
    }, [u]);
    m(() => () => {
      o.current && clearTimeout(o.current);
    }, []);
    const W = () => {
      O(!0), b == null || b();
    };
    return m(() => {
      w && I && setTimeout(() => {
        var t;
        if (S.current) {
          const e = {
            type: "init-atticus",
            payload: {
              category: v || null,
              suburb: $ || null,
              suburbId: U || null,
              ...E ? { fromFirm: E } : {},
              utm: {
                utmSource: s.utm_source || void 0,
                utmContent: K || void 0,
                utmCampaign: s.utm_campaign || void 0,
                utmMedium: s.utm_medium || void 0,
                utmTerm: s.utm_term || v || void 0,
                gclid: s.gclid || void 0,
                gaClientId: _ || void 0
              },
              source: L,
              sourceUrl: window.location.href,
              // Include all stored query string parameters
              queryParams: s,
              // Include context if provided
              ...y ? { context: y } : {},
              // Include user if provided
              ...c ? {
                user: {
                  name: c.name,
                  email: c.email,
                  phone: c.phone
                }
              } : {}
            }
          };
          try {
            (t = S.current.contentWindow) == null || t.postMessage(e, "*");
          } catch (r) {
            console.error("❌ Error sending postMessage:", r);
          }
        }
      }, 100);
    }, [
      w,
      I,
      v,
      $,
      U,
      K,
      E,
      s,
      L,
      y,
      c
    ]), m(() => {
      const t = async (e) => {
        var r, A, k, q, x, H;
        if (((r = e.data) == null ? void 0 : r.type) === "close-atticus") {
          const i = {
            email: (A = e.data) == null ? void 0 : A.email,
            jobId: (k = e.data) == null ? void 0 : k.jobId
          };
          window.sessionStorage.removeItem(re), i.jobId && window.sessionStorage.setItem(ne, i.jobId), i.email && window.sessionStorage.setItem(ae, i.email);
          const J = window.sessionStorage.getItem(
            D
          );
          h ? await h(i) : J && (window.sessionStorage.removeItem(D), window.location.href = `/case/${J}`), l();
        } else if (((q = e.data) == null ? void 0 : q.type) === "share-brief-success") {
          const i = {
            prematterId: (x = e.data) == null ? void 0 : x.prematterId,
            jobId: (H = e.data) == null ? void 0 : H.jobId
          };
          i.prematterId && window.sessionStorage.setItem(
            D,
            i.prematterId
          ), p == null || p(i);
        }
      };
      return window.addEventListener("message", t), () => {
        window.removeEventListener("message", t);
      };
    }, [l, h, p]), te(Q, () => ({
      openModal: F,
      closeModal: l
    })), !w && !M ? null : se(
      /* @__PURE__ */ a(
        "div",
        {
          className: `${n.modal} ${M ? n.closing : ""}`,
          onClick: l,
          children: /* @__PURE__ */ V(
            "div",
            {
              className: `${n.modalContent} ${M ? n.closing : ""}`,
              onClick: (t) => t.stopPropagation(),
              children: [
                /* @__PURE__ */ a("div", { className: n.close, onClick: l, children: /* @__PURE__ */ a(ie, {}) }),
                !I && /* @__PURE__ */ a("div", { className: n.loadingSpinner, children: /* @__PURE__ */ a("div", { className: n.spinner }) }),
                /* @__PURE__ */ a(
                  "iframe",
                  {
                    ref: S,
                    src: T,
                    width: "100%",
                    height: "100%",
                    onLoad: W,
                    className: n.iframe,
                    title: "Atticus AI Assistant",
                    style: { opacity: I ? 1 : 0 }
                  }
                )
              ]
            }
          )
        }
      ),
      document.body
    );
  }
);
le.displayName = "AtticusModal";
export {
  le as AtticusModal
};
